const host = window.location.hostname;
let baseURL = host === "localhost" ? "http://localhost:2000" : "https://api.pgkonnect.com";

export const config = {  
  "BASE_URL": baseURL,  
  "API_URL": baseURL + "/api/v1",    
  "MEDIA_URL": baseURL + "/media",
  "APP_NAME": "PGKPL",
  "APP_VERSION": "1.0.0"
}